(function() {
  var SidebarKo,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  SidebarKo = App.loadClass("core::viewmodels/filters/Sidebar");

  exports.Hybrids_Handler = (function(superClass) {
    extend(Hybrids_Handler, superClass);

    function Hybrids_Handler() {
      return Hybrids_Handler.__super__.constructor.apply(this, arguments);
    }

    Hybrids_Handler.prototype.init = function() {
      this.layoutUrl = 'backend/portal/hybrids/';
      return this.loadLayout();
    };

    Hybrids_Handler.prototype.afterLoadLayout = function() {
      var filters;
      filters = [
        {
          name: 'Inventory Filters',
          filters: [
            {
              name: 'crops',
              display_name: 'Crop'
            }, {
              name: 'status',
              display_name: 'Status',
              deletable: false,
              control_type: 'single_dropdown',
              values: [
                {
                  key: 'all',
                  value: 'All'
                }, {
                  key: 'disabled',
                  value: 'Disabled'
                }, {
                  key: 'enabled',
                  value: 'Enabled'
                }
              ],
              selected_values: [
                {
                  key: 'all',
                  value: 'All'
                }
              ]
            }
          ]
        }
      ];
      this.sidebar = new SidebarKo(filters);
      ko.applyBindings(this.sidebar, $(this.layoutSelector)[0]);
      this.sidebar.fetchFilters('backend/portal/hybrids/filters', (function(_this) {
        return function() {
          _this.hybrids_dialog = _this.createSubHandler('portal::handlers/hybrids/Hybrids_Dialog');
          if (_this.hybrids_dialog) {
            return _this.hybrids_dialog.init();
          }
        };
      })(this));
      $(this.layoutSelector).find('.apply-filters').bind('click', (function(_this) {
        return function() {
          return _this.hybrids_dialog.refresh();
        };
      })(this));
      return $(this.layoutSelector).find('.report-applied-filters').undelegate().delegate('.applied-filter-header', 'click', function() {
        $(this).siblings('.applied-filter-value-container').slideToggle('fast');
        if ($(this).find('.caret-arrow').hasClass('caret-right')) {
          return $(this).find('.caret-arrow').removeClass('caret-right');
        } else {
          return $(this).find('.caret-arrow').addClass('caret-right');
        }
      });
    };

    return Hybrids_Handler;

  })(Handler);

}).call(this);
